import React from "react";
export default function ModuleHeader (props){
  return (
    <tr class="border-bottom-0">
      <td colSpan={props.colSpan ? props.colSpan :"11"} className="text-left">
        <h6 className="mb-0 text-primary font-weight-bold">
          {props.header}
        </h6>
      </td>
    </tr>
  );
}



// WEBPACK FOOTER //
// ./src/components/Costing/ModuleHeader/index.js